class IaBlogTabs extends HTMLElement {
  connectedCallback() {
    this.allUrl = this.dataset.allUrl || window.location.pathname;
    this.tabs = Array.from(this.querySelectorAll("[data-ia-blog-tab]"));
    this.panels = Array.from(this.querySelectorAll("[data-ia-blog-panel]"));
    
    this.bindTabs();
    this.initFromURL();
  }

  bindTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        // If data-no-ajax is present, allow default navigation
        if (tab.dataset.noAjax === "true") {
          return;
        }
        
        e.preventDefault();
        const blogHandle = tab.dataset.blogHandle;
        const blogUrl = tab.dataset.blogUrl;
        this.switchTab(blogHandle, blogUrl);
      });
    });
  }

  initFromURL() {
    const currentPath = window.location.pathname;
    const activeTab = this.tabs.find(tab => {
      const tabUrl = tab.dataset.blogUrl;
      return currentPath === tabUrl || currentPath.startsWith(tabUrl + '/');
    });
    
    if (activeTab) {
      const blogHandle = activeTab.dataset.blogHandle;
      this.switchTab(blogHandle, activeTab.dataset.blogUrl, false);
    }
  }

  async switchTab(blogHandle, blogUrl, updateHistory = true) {
    // Update tabs active state
    this.tabs.forEach((tab) => {
      const active = tab.dataset.blogHandle === blogHandle;
      tab.classList.toggle("is-active", active);
    });

    // Update panels visibility
    this.panels.forEach((panel) => {
      const active = panel.dataset.blogHandle === blogHandle;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });

    // Update URL path
    if (updateHistory && blogUrl) {
      window.history.pushState({}, "", blogUrl);
    }

    // Fetch and update hero section if blogUrl is provided
    if (blogUrl) {
      await this.updateHeroSection(blogUrl);
    }



    // Dispatch custom event
    this.dispatchEvent(
      new CustomEvent("ia-blog-tabs:changed", {
        bubbles: true,
        detail: { blogHandle, blogUrl },
      })
    );
  }

  async updateHeroSection(blogUrl) {
    try {
      const res = await fetch(blogUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } });
      
      if (!res.ok) return;
      
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      
      // Find hero section in fetched page
      const fetchedHero = doc.querySelector(".ia-blog-hero");
      
      // Find hero section in current page
      const currentHero = document.querySelector(".ia-blog-hero");
      
      if (fetchedHero && currentHero) {
        currentHero.innerHTML = fetchedHero.innerHTML;
      }
    } catch (err) {
      console.error("[ia-blog-tabs] Error updating hero:", err);
    }
  }
}

if (!customElements.get("ia-blog-tabs")) {
  customElements.define("ia-blog-tabs", IaBlogTabs);
}
